<template>
  <div class="grid-container full">
    <div class="grid-x page-contents-8" >
      <div class=" small-8 medium-11 cell">
        <h2>CPD accredited</h2>
        <p>Certified as conforming to continuous professional development principles.</p>
      </div>
      <div class=" small-4 medium-1 cell text-center">
        <img
          class="bclpImg"
          src="@/assets/img/icons/cpd-certified.png" alt="CPD Certified Logo"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RareAwardsSection',
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  .full {
    background-color: #ffffff;
    color: $main-text;
  }

  h2 {
    color: $main-text;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
  }

  p {
    color: $main-text;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
  }

  @media only screen and (max-width: 640px)  {
    .full {
      height: 200px;
    }

    h2 {
      font-size: 26px;
      font-weight: bold;
      line-height: 1.5;
      margin-top: 33px;
      margin-bottom: 10px;
    }

    p {
      font-size: 18px;
      margin-bottom: 20px;
    }

    .bclpImg {
      display: block;
      margin: 80px auto 30px auto;
      max-height: 80px;
    }
  }

  @media only screen and (min-width: 641px)  {
    .full {
      height: 300px;
    }

    h2 {
      font-size: 56px;
      font-weight: bold;
      line-height: 1.67;
      margin-top: 63px;
    }

    p {
      font-size: 24px;
      font-weight: normal;
      line-height: 1.92;
      margin-bottom: 75px;
    }

    .bclpImg {
      display: block;
      float: right;
      margin-top: 60px;
      max-width: 180px;
    }

    .quoteImg {
      height: 49px;
      margin: 76px 0 20px 0;
    }
  }


</style>



// WEBPACK FOOTER //
// src/pages/homeProducts/homeProductsHemisphere/components/RareHomeProductsHemisphereBanner.vue